import _typeof from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, createVNode as _createVNode, isRef as _isRef } from "vue";
var _hoisted_1 = {
  key: 0
};
var _hoisted_2 = {
  key: 0,
  class: "btns"
};
var _hoisted_3 = {
  key: 1
};
import { createIconNode } from '@/component-create/utils/common';

import { toRefs, ref, nextTick } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'XDialog',
  props: {
    title: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '40%'
    },
    footers: {
      type: Array
    },
    customContent: [Function, Object],
    getInstance: Function,
    handler: Object
  },
  emits: ['save'],
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose,
      __emit = _ref.emit;
    var prop = __props;
    var emit = __emit;
    var _toRefs = toRefs(prop),
      title = _toRefs.title,
      footers = _toRefs.footers,
      getInstance = _toRefs.getInstance,
      customContent = _toRefs.customContent,
      width = _toRefs.width;
    var visible = ref(false);
    var instance = new Proxy({}, {});
    var contentNode = ref();
    var customProp = ref();
    var customRef = ref();
    /**
     * 暴露属性方法
     */
    if (getInstance !== null && getInstance !== void 0 && getInstance.value) {
      getInstance.value(instance);
    }
    instance.open = open;
    instance.close = close;
    /**
     * 打开对话框
     * @param data
     */
    function open(data) {
      return new Promise(function (resolve) {
        visible.value = true;
        customProp.value = data;
        if (prop.customContent && typeof prop.customContent === 'function') {
          contentNode.value = prop.customContent(data);
        }
        nextTick(function () {
          resolve(true);
        });
      });
    }
    /**
     * 关闭对话框
     */
    function close() {
      visible.value = false;
      if (customRef.value && customRef.value.__close) {
        customRef.value.__close();
      }
    }
    /**
     * 取消
     */
    function cancle() {
      close();
    }
    function save() {
      emit('save');
    }
    __expose({
      open: open,
      close: close
    });
    /**
     * 创建按钮
     * @param el VNode绘制函数
     */
    function createButton(el) {
      return el(customRef);
    }
    return function (_ctx, _cache) {
      var _component_el_button = _resolveComponent("el-button");
      var _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _isRef(visible) ? visible.value = $event : null;
        }),
        title: _unref(title),
        width: _unref(width),
        onClose: close
      }, {
        footer: _withCtx(function () {
          return [_unref(footers) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_unref(footers).length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(footers), function (item, index) {
            return _openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(["item", {
                'first': index === 0
              }])
            }, [item.el ? (_openBlock(), _createBlock(_resolveDynamicComponent(createButton(item.el)), {
              key: 0
            })) : (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              type: item.type,
              icon: _unref(createIconNode)(item.icon),
              onClick: item.handler
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.text), 1)];
              }),
              _: 2
            }, 1032, ["type", "icon", "onClick"]))], 2);
          }), 128))])) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_el_button, {
            onClick: cancle
          }, {
            default: _withCtx(function () {
              return _cache[1] || (_cache[1] = [_createTextVNode("取消")]);
            }),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            onClick: save
          }, {
            default: _withCtx(function () {
              return _cache[2] || (_cache[2] = [_createTextVNode("确认")]);
            }),
            _: 1
          })]))];
        }),
        default: _withCtx(function () {
          return [_createElementVNode("div", null, [_renderSlot(_ctx.$slots, "default"), _unref(contentNode) ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(contentNode)), {
            key: 0
          })) : _createCommentVNode("", true), _typeof(_unref(customContent)) === 'object' ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(customContent)), _mergeProps({
            key: 1,
            ref_key: "customRef",
            ref: customRef
          }, _unref(customProp) || {}), null, 16)) : _createCommentVNode("", true)])];
        }),
        _: 3
      }, 8, ["modelValue", "title", "width"]);
    };
  }
});